/*
  Gates the theme's checkout button behind the age + terms checkbox rendered by
  snippets/cart-age-terms.liquid.

  This lives in its own file, not inline in the snippet, because the cart drawer is
  re-rendered with innerHTML on every cart change — and scripts inserted that way never
  execute. Loaded once from layout/theme.liquid, it works through event delegation, so it
  keeps working across re-renders.

  Scope: this only stops the theme's own button. Shopify's checkout is external, so
  express payment buttons and direct /checkout links are unaffected.
*/
(function () {
  if (window.cartAgeTermsReady) return;
  window.cartAgeTermsReady = true;

  var DRAWER = '#CartDrawer, cart-drawer';

  function isInDrawer(el) {
    return !!(el.closest && el.closest(DRAWER));
  }

  // The drawer and the cart page each carry their own checkbox. Pair a button with the
  // one on its own side, so the hidden drawer never blocks the cart page.
  function partnerBox(button) {
    var wanted = isInDrawer(button);
    var boxes = document.querySelectorAll('[data-age-terms-input]');
    for (var i = 0; i < boxes.length; i++) {
      if (isInDrawer(boxes[i]) === wanted) return boxes[i];
    }
    return null;
  }

  function refresh() {
    var buttons = document.querySelectorAll('[data-age-terms-gate]');
    for (var i = 0; i < buttons.length; i++) {
      var box = partnerBox(buttons[i]);
      buttons[i].classList.toggle('is-blocked', !!box && !box.checked);
    }
  }

  // Capture phase, so this runs before the theme's own submit handler and can stop it.
  // The button stays enabled on purpose: a disabled button explains nothing, this way the
  // shopper is told what is missing.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest('[data-age-terms-gate]') : null;
      if (!button) return;

      var box = partnerBox(button);
      if (!box || box.checked) return;

      event.preventDefault();
      event.stopPropagation();

      var wrapper = box.closest('.cart-age-terms');
      var error = wrapper && wrapper.querySelector('[data-age-terms-error]');
      if (error) error.hidden = false;
      // Shake the consent box so it is obvious what is missing (10/10/2026).
      if (wrapper) {
        wrapper.classList.remove('is-shaking');
        void wrapper.offsetWidth; // restart the animation on repeated taps
        wrapper.classList.add('is-shaking');
        wrapper.addEventListener('animationend', function done() {
          wrapper.classList.remove('is-shaking');
          wrapper.removeEventListener('animationend', done);
        });
        if (wrapper.scrollIntoView) wrapper.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      box.focus({ preventScroll: true });
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-age-terms-input]')) return;
    var wrapper = event.target.closest('.cart-age-terms');
    var error = wrapper && wrapper.querySelector('[data-age-terms-error]');
    if (error && event.target.checked) error.hidden = true;
    refresh();
  });

  // Re-apply after the drawer re-renders, which also resets the checkbox.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      refresh();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  refresh();
})();
